import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './BlueBtn.module.css';
import {
	useGetUserBasketQuery,
	useDecrementItemFromBasketMutation,
	useAddItemToBasketMutation
} from '../../store/api/basket.api';

import { useCreateOrderMutation } from '../../store/api/order.api';
import { useCreateTopUpOrderMutation } from '../../store/api/topup.api';
import { useDbUserId } from '../../hooks/useDbUserId';
import { sendAddToCart } from '../../utils/yandexMetrika';

import incrIcon from '../../assets/increment-icon.svg';
import basketIcon from '../../assets/basket-icon.svg'
import decIcon from '../../assets/decrement-icon.svg';

export const BlueBtn = ({
	addingOrderCreate,
	price,
	text,
	type,
	itemId,
	editionId,
	subscriptionId,
	orderData,
	style,
	itemType,
	disabled = false
}) => {
	const navigate = useNavigate();
	const { dbUserId } = useDbUserId();
	const schema = window.sessionStorage.getItem('schema');

	const [createOrder] = useCreateOrderMutation();
	const [createTopUpOrder] = useCreateTopUpOrderMutation();

	const {
		data,
		refetch,
		isUninitialized
	} = useGetUserBasketQuery(
		{ userId: dbUserId, schema },
		{ skip: !dbUserId || schema === 'xbox' }
	);


	const [addItemToBasket] = useAddItemToBasketMutation();
	const [decrementItemFromBasket] = useDecrementItemFromBasketMutation();

	const itemInBasket = data?.items?.find(basketItem => {
		if (editionId) return basketItem.editionId === editionId;
		if (itemId) return basketItem.itemId === itemId;
		if (subscriptionId) return basketItem.subscriptionId === subscriptionId;
		return false;
	});

	const [quantity, setQuantity] = useState(0);

	useEffect(() => {
		if (!isUninitialized && dbUserId) {
			refetch();
		}
	}, [isUninitialized, dbUserId, refetch]);

	useEffect(() => {
		setQuantity(itemInBasket?.quantity || 0);
	}, [itemInBasket]);

	const decrement = async (e) => {
		e.preventDefault();
		if (quantity > 0) {
			await decrementItemFromBasket({
				data: { itemId, subscriptionId, userId: dbUserId, editionId },
				schema
			});

		}
	};

	const increment = async (e) => {
		e.preventDefault()
		await addItemToBasket({
			data: { itemId, subscriptionId, userId: dbUserId, editionId },
			schema
		});

	}

	const handleClick = async (e) => {
		e.preventDefault();

		if (price) {
			await addingOrderCreate();
			return
		}
		if (type === 'toBasket' || quantity > 0) {
			navigate('/basket');
			return
		}

		if (orderData && type === 'pay') {
			// Handle top-up orders for main games section (schema === '')
			if (orderData.isTopUpOrder) {
				if (!orderData.email) {
					alert('Пожалуйста, укажите почту для чека!');
					return;
				}
				if (!orderData.quoteId) {
					alert('Дождитесь актуального расчёта заказа');
					return;
				}
				
				try {
					const response = await createTopUpOrder({
						data: {
							email: orderData.email,
							quoteId: orderData.quoteId,
							promoCodeId: orderData.promoCodeId,
						},
					}).unwrap();
					
					if (response?.paymentUrl) {
						window.Telegram?.WebApp?.openLink(response.paymentUrl);
					} else {
						alert('Не удалось получить ссылку на оплату, обратитесь в поддержку');
					}
				} catch (error) {
					console.error('Top-up order error:', error);
					if (error?.status === 409 && error?.data?.quoteId) {
						orderData.onQuoteStale?.(error.data);
						alert(error.data.message || 'Расчёт изменился. Проверьте его и подтвердите оплату ещё раз.');
						return;
					}
					alert(error?.data?.message || 'Ошибка при создании заказа пополнения');
				}
				return;
			}

			// Handle regular orders for other schemas
			const { email, login, password } = orderData.inShopInfo;

			if (orderData.forNewAccount){
				if (email) {
					const response = await createOrder({ data: orderData, schema });
					if (response?.data?.paymentUrl) {
						window.Telegram?.WebApp?.openLink(response.data.paymentUrl);
					} else {
						alert('Не удалось получить ссылку на оплату, обратитесь в поддержку');
					}
				} else {
					alert('Пожалуйста, заполните все поля!');
				}
			} else {
				if (email && login && password) {
					const response = await createOrder({ data: orderData, schema });
					if (response?.data?.paymentUrl) {
						window.Telegram?.WebApp?.openLink(response.data.paymentUrl);
					} else {
						alert('Не удалось получить ссылку на оплату, обратитесь в поддержку');
					}
				} else {
					alert('Пожалуйста, заполните все поля!');
				}
			}
			return
		}

		const resItem = await addItemToBasket({
			data: { itemId, subscriptionId, userId: dbUserId, editionId, type: itemType },
			schema
		});
		sendAddToCart(resItem.data, resItem.data.editionId ? 'edition' : resItem.data.subscriptionId ? 'sub' : 'item', schema)
		await refetch();

	};
	return (
		<div style={schema === 'steam' ? { bottom: 100 } : {}}>
			<Link
				to="#"
				className={`${styles.main} ${type === 'main' || type === 'inWishlist' ? styles.fix : ''} ${disabled ? styles.disabled : ''} ${quantity > 0 && type !== 'inBasket' ? styles.quantityAdd : ''}`}
				style={style}
				onClick={!disabled ? handleClick : undefined}
			>
				{quantity > 0 ?
					<>
						{
							type === 'inBasket' ?
								<>
									<img
										className={styles.icon_dec}
										src={decIcon}
										alt="decIcon"
										onClick={decrement}
									/>
									<span>{quantity}</span>
									<img
										className={styles.icon_inc}
										src={incrIcon}
										alt="incrIcon"
										onClick={increment}
									/>
								</>
								:
								<p>Перейти</p>
						}
					</>
					: type === 'toBasket' || type === 'pay' || type === 'steamAdding' || type === 'inItem' || type === 'inSharingItem' ? <p>{text}</p> : (
						<img style={{ width: 22, height: 22 }} className={styles.mainIcon} src={basketIcon} alt='basketIcon' />
					)
				}
			</Link>
		</div>
	);
};
